var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 10.666L10.6693 7.33268H8.66927V2.66602H7.33594V7.33268H5.33594L8.0026 10.666Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 12.0007H2.66927V7.33398H1.33594V12.0007C1.33594 12.736 1.93394 13.334 2.66927 13.334H13.3359C14.0713 13.334 14.6693 12.736 14.6693 12.0007V7.33398H13.3359V12.0007Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxDownload);
export default __webpack_public_path__ + "static/media/bx-download.135cf6010d56dff4daeaec640ad2c01b.svg";
export { ForwardRef as ReactComponent };